import { GlassCard } from '@/components/ui/layout/card';
import { CardHeader, CardTitle, CardContent } from '@/components/ui/layout/card';
import { Button } from '@/components/ui/button';
import { AlertTriangle } from 'lucide-react';
import { isNative } from '@/lib/platform';

export interface ErrorDisplayProps {
  error: Error | null;
  onReset: () => void;
}

export function ErrorDisplay({ error, onReset }: ErrorDisplayProps) {
  const handleGoToToday = () => {
    onReset();
    if (isNative()) {
      window.location.hash = '#/today';
    } else {
      window.location.href = '/today';
    }
  };

  return (
    <div className="min-h-[100svh] flex items-center justify-center p-4">
      <GlassCard className="max-w-md w-full">
        <CardHeader>
          <div className="flex items-center gap-2">
            <AlertTriangle className="h-5 w-5 text-destructive" />
            <CardTitle>Something went wrong</CardTitle>
          </div>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-sm text-muted-foreground">
            An unexpected error occurred. Please try refreshing the page.
          </p>
          {error && (
            <details className="text-xs text-muted-foreground">
              <summary className="cursor-pointer mb-2">Error details</summary>
              <pre className="mt-2 p-2 bg-muted rounded overflow-auto">
                {error.message}
              </pre>
            </details>
          )}
          <div className="flex gap-2">
            <Button
              onClick={() => {
                onReset();
                window.location.reload();
              }}
              className="flex-1"
            >
              Refresh Page
            </Button>
            <Button
              variant="outline"
              onClick={handleGoToToday}
              className="flex-1"
            >
              Go to Today
            </Button>
          </div>
        </CardContent>
      </GlassCard>
    </div>
  );
}
